import React from "react";
import {PaymentElement, useElements, useStripe} from "@stripe/react-stripe-js";
import {SetupIntent, StripeError} from "@stripe/stripe-js";
import {Button} from "@mui/material";

const PaymentDetailsCheckout = () => {

    const stripe = useStripe();
    const elements = useElements();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!stripe || !elements) {
            return;
        }

        const { setupIntent, error }: { setupIntent?: SetupIntent; error?: StripeError } = await stripe.confirmSetup({
            elements,
            confirmParams: {
                return_url: `${window.location.origin}/setup-complete`,
            },
            redirect: 'if_required',
        });
    };

    return (
        <form id="payment-form" onSubmit={handleSubmit}>
            <PaymentElement id="payment-element"/>
            <Button variant={"firstVariant"} sx={{mt: 4, mb: 4}} type={"submit"}>
                Enregistrer
            </Button>
        </form>
    );
}

export default PaymentDetailsCheckout
